import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AngularFire, FirebaseListObservable } from 'angularfire2';
import {BillSummaryPage} from '../../index';
import {ThemeService, AuthService} from '../../../providers/index';

@Component({
  selector: 'page-bill-create',
  templateUrl: 'bill-create.html'
})
export class BillCreatePage {

  billList: FirebaseListObservable<any>;
  project: string;

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public af: AngularFire, private _theme: ThemeService,private _auth: AuthService) {

    this.billList = af.database.list('/bills');

    console.log('Theme: ' + this._theme.getNameOfTheme());

    this.project = this._theme.getNameOfTheme();

  }


  createBill(name, amount, dueDate) {
    this.billList.push({
      name: name,
      amount: amount,
      dueDate: dueDate,
      paid: false
    }).then( newBill => {
      console.log('resident created: ' + name +', ' + amount +', ' + dueDate );
      this.navCtrl.push(BillSummaryPage); //TODO: This is cheating
    }, error => {
      console.log('ERROR: resident not created: ' + name +', ' + amount +', ' + dueDate );
      console.log(error);
    });
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad BillCreatePage');
  }
  // Only go here if we need to
  ionViewCanEnter(): boolean {
    if(this._auth.authenticated){
      console.log('Authenticated so you can see this page: ');
      return true;
    } else {
      console.log('Not Authenticated so you cannot see this page: '); //TODO: Add reference to page
      return false;
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/bill/bill-create/bill-create.ts